'use client';
import Image from 'next/image';
import styles from './MobileAbout.module.css';
import { useEffect } from 'react';
import gsap from 'gsap';

export default function MobileAbout() {
  useEffect(()=>{        gsap.to("#navbar", { autoAlpha: 1 });
},[])
  return (
    <div className={styles.mobileContainer}>
      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.backgroundImage}>
          <Image
            src="https://longevity20155.sirv.com/OMEGA.webp"
            alt="OMEGA Product"
            fill
            style={{ objectFit: 'contain' }}
            unoptimized
          />
        </div>
        <h1 className={styles.heroText}>Logvplus</h1>
        <p className={styles.subtitle}>PREMIUM SUPPLEMENTS</p>
      </section>

      {/* About Content Section */}
      <section className={styles.aboutSection}>
        <h2 className={styles.sectionTitle}>About</h2>
        <p className={styles.description}>
          Chez logvplus, nous croyons que la santé et le bien-être commencent par une nutrition optimale. 
          C'est pourquoi nous développons des compléments alimentaires innovants et de haute qualité.
        </p>
      </section>

      {/* Products Grid Section */}
      <section className={styles.productsSection}>
        <h2 className={styles.sectionTitle}>Our Products</h2>
        <div className={styles.productsGrid}>
          {[
            { src: 'https://longevity20155.sirv.com/zinc/1.webp', name: 'ZINC', color: 'linear-gradient(135deg, #490000 0%, #000 20%)' },
            { src: 'https://longevity20155.sirv.com/minci/1.webp', name: 'MINCI', color: 'linear-gradient(135deg, #2a0a0a 0%, #000 20%)' },
            { src: 'https://longevity20155.sirv.com/testo/1.webp', name: 'TESTO', color: 'linear-gradient(135deg, #6b0000 0%, #000 20%)' },
            { src: 'https://longevity20155.sirv.com/zinc/3.webp', name: 'FERTI', color: 'linear-gradient(135deg, #3d0a0a 0%, #000 20%)' },
          ].map((product, i) => (
            <div
              key={i}
              className={styles.productCard}
              style={{ background: product.color }}
            >
              <div className={styles.productImageWrapper}>
                <Image
                  src={product.src}
                  alt={product.name}
                  fill
                  style={{ objectFit: 'contain' }}
                  unoptimized
                />
              </div>
              <h3 className={styles.productName}>{product.name}</h3>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
